import { ApiError as ApiErrorCore } from '../generated';

export interface CssApiError extends ApiErrorCore {}

/**
 * Checks if given error is of type ApiError.
 */
export const isCssApiError = (error: unknown): error is CssApiError => {
  return error instanceof ApiErrorCore;
};

/**
 * Checks if given error contains given message.
 */
export const cssApiErrorContains = (
  error: CssApiError,
  message: string,
): boolean => {
  const errorMessage = (getErrorFromBody(error) ?? '').toLowerCase();

  return errorMessage.indexOf(message.toLowerCase()) > -1;
};

const getErrorFromBody = (error: CssApiError): string | undefined => {
  if (!('error' in error.body) || !error.body.error) {
    return undefined;
  }

  return String(error.body.error);
};
